const error404 = {
    title: 'Error 404',
    header: 'Not Found',
    message: "You just hit a route that doesn't exist.",
    link: 'Go back to Home page',
}

export default error404
